import { adapterPlanogramItemToPlanogramItemCommon } from "@CommonAdapters/pog";
import { PlanogramItem } from "@CommonTypes/merchflow/pog/item";
import { BaseProduct } from "@CommonTypes/merchflow/pog/product";
import { PlanogramPegboardPlacement } from "@CommonTypes/merchflow/pog/pegboard";
import { PlanogramShelf } from "@CommonTypes/merchflow/pog/shelf";

export type PlanogramItemViewKind = "SHELF_ITEM" | "PEGBOARD_PLACEMENT";

export interface PlanogramItemView extends BaseProduct {
  kind: PlanogramItemViewKind;
  shelf?: PlanogramShelf | null;
  getCapacity?: () => number;
  getDaysOfSupply?: () => number;
  getDaysOfSupplyPercentage?: () => number;
  getMOSPercentage?: () => number;
}

export const toPlanogramItemView = (item: PlanogramItem): PlanogramItemView => ({
  kind: "SHELF_ITEM",
  ...adapterPlanogramItemToPlanogramItemCommon(item),
  shelf: item.shelf,
  getCapacity: () => item.getCapacity(),
  getDaysOfSupply: () => item.getDaysOfSupply(),
  getDaysOfSupplyPercentage: () => item.getDaysOfSupplyPercentage(),
  getMOSPercentage: () => item.getMOSPercentage(),
});

export const toPegboardPlacementView = (
  pegboardPlacement: PlanogramPegboardPlacement,
): PlanogramItemView => ({
  kind: "PEGBOARD_PLACEMENT",
  ...pegboardPlacement.pegProduct,
  uniqueId: pegboardPlacement.uniqueId,
  shelf: null,
});

export const getPlanogramItemDisplayName = (item: PlanogramItemView) =>
  item.productCode ? `${item.productCode} - ${item.name}` : item.name || item.uniqueId;

export const getNewItemLabel = (item: { newItemFlag: boolean }, t?: (key: string) => string) =>
  item.newItemFlag ? (t ? t("highlights.newItemBadge") : "PI") : null;
